module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/dragos.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/dragos.jpg
// module id = 609
// module chunks = 0